$(document).ready(function () {
	$('[data-toggle="filters-remove-current"]').click(function () {
		let $self = $(this);

		var params = {
			_token: App.csrf,
			url: location.href,
			name: $(this).data('name'),
			value: $(this).data('value')
		};

		$.post('/catalog/remove_filter', params, function (data) {
			location.href = data.redirect_to;
		});

		return false;
	});
});